import { sendToApi } from 'api/client'
import {
  CreateInformalFeedbackRequestInput,
  InformalFeedbackRequest,
  QueryOptions,
} from '../InformalFeedbackRequestsClient'

// TODO: Move to original InformalFeedbackRequestsClient file
export const InformalFeedbackRequestsClient = {
  index: async (almanacFileId: string, { items, page, states, automated }: QueryOptions = {}) => {
    return sendToApi<{ informal_feedback_requests: InformalFeedbackRequest[] }>(
      `/almanac_files/${almanacFileId}/informal_feedback_requests`,
      {
        method: 'GET',
        params: {
          items,
          page,
          states: states?.join(','),
          automated,
        },
      },
    )
  },

  show: async (id: number) => {
    return sendToApi<{ informal_feedback_request: InformalFeedbackRequest }>(`/informal_feedback_requests/${id}`, {
      method: 'GET',
    })
  },

  // Allow almanacFileId to be undefined to indicate that the review's article needs to be created too
  create: async (almanacFileId: string, input: CreateInformalFeedbackRequestInput) => {
    const {
      subject,
      message,
      htmlMessage,
      endsOn,
      reviewers,
      emailReviewers,
      channelReviewers,
      permission,
      addMembers,
    } = input

    return sendToApi<{ informal_feedback_request: InformalFeedbackRequest }>(
      `/almanac_files/${almanacFileId}/informal_feedback_requests`,
      {
        method: 'POST',
        body: {
          subject,
          message,
          html_message: htmlMessage,
          ends_on: endsOn,
          reviewers,
          email_reviewers: emailReviewers,
          channel_reviewers: channelReviewers,
          permission,
          add_members: addMembers,
        },
      },
    )
  },
}
